<template>
	<div>
		<div class="chat-item" :class="{ active }" @contextmenu.prevent="showRightMenu($event)">
			<div class="chat-left">
				<head-image :url="conversation.headImage" :name="conversation.showName" :size="45" :online="online"
					:id="isPrivate ? conversation.targetId : 0" :isShowUserInfo="false"></head-image>
				<div v-show="!conversation.isDnd && conversation.unreadCount > 0" class="unread-text">{{
					conversation.unreadCount }}</div>
			</div>
			<div class="chat-right">
				<div class="chat-name">
					<div class="chat-name-text" :title="conversation.showName">{{ conversation.showName }}</div>
					<div v-if="conversation.companyName" class="company-tag-mini" :title="conversation.companyName">@{{
						conversation.companyName
					}}</div>
					<div class="chat-tag">
						<el-tag v-if="isSystem" type="danger">{{ $t('chat.official') }}</el-tag>
					</div>
					<div class="chat-time-text">{{ showTime }}</div>
				</div>
				<div class="chat-content">
					<div class="chat-at-text">{{ atText }}</div>
					<div class="chat-send-name" v-show="isShowSendName">{{ conversation.sendNickName + ':&nbsp;' }}
					</div>
					<div v-if="conversation.draftText" class="chat-draft-text">{{ $t('chat.draft') }}</div>
					<div v-if="conversation.draftText" class="chat-content-text"
						v-html="$emo.transform($str.html2Escape(conversation.draftText), 'emoji-small')"></div>
					<div v-else class="chat-content-text"
						v-html="$emo.transform($str.html2Escape(conversation.lastContent), 'emoji-small')"></div>
					<div class="icon iconfont icon-dnd" v-if="conversation.isDnd"></div>
				</div>
			</div>
			<div v-if="conversation.isTop" class="chat-top-badge" :title="$t('chat.topTip')">
				<i class="icon iconfont icon-fixed"></i>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {}
	},
	props: {
		conversation: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.conversation);
		},

	},
	computed: {
		isShowSendName() {
			return this.conversation.sendNickName && !this.conversation.draftText;
		},
		showTime() {
			return this.$date.toTimeText(this.conversation.lastSendTime, true)
		},
		atText() {
			if (this.conversation.atMe) {
				return this.$t('chat.atMeTag');
			} else if (this.conversation.atAll) {
				return this.$t('chat.atAll');
			}
			return "";
		},
		menuItems() {
			let items = [];
			if (!this.conversation.isTop) {
				items.push({
					key: 'TOP',
					name: this.$t('chat.top')
				})
			} else {
				items.push({
					key: 'TOP',
					name: this.$t('chat.untop')
				})
			}
			if (this.isPrivate || this.isGroup) {
				items.push({
					key: 'INFO',
					name: this.$t('group.viewProfile')
				});
			}
			if (this.conversation.isDnd) {
				items.push({
					key: 'DND',
					name: this.$t('chat.notifyOn')
				})
			} else {
				items.push({
					key: 'DND',
					name: this.$t('chat.dndLabel')
				})
			}
			items.push({
				key: 'DELETE',
				name: this.$t('chat.deleteChatItem'),
				danger: true
			})
			return items;
		},
		online() {
			if (this.isPrivate) {
				let friend = this.friendStore.findFriend(this.conversation.targetId);
				return friend && friend.online;
			}
			return false;
		},
		isPrivate() {
			return this.$enums.CONVERSATION_TYPE.PRIVATE == this.conversation.type
		},
		isGroup() {
			return this.$enums.CONVERSATION_TYPE.GROUP == this.conversation.type
		},
		isSystem() {
			return this.$enums.CONVERSATION_TYPE.SYSTEM == this.conversation.type
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 54px;
	display: flex;
	position: relative;
	margin: 0 3px;
	padding: 5px 8px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;
	border-radius: 10px;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.unread-text {
			position: absolute;
			background-color: var(--im-color-danger);
			right: -4px;
			top: -8px;
			color: white;
			border-radius: 30px;
			padding: 1px 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1px solid #f1e5e5;
		}
	}

	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		position: relative;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			align-items: center;
			line-height: 26px;
			height: 26px;

			.chat-name-text {
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.chat-tag {
				flex: 1;
				display: flex;
				align-items: center;
			}

			.chat-time-text {
				font-size: var(--im-font-size-smaller);
				text-align: right;
				color: var(--im-text-color-light);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 2px;
				min-width: 60px;
			}
		}

		.chat-content {
			display: flex;
			line-height: 20px;
			height: 20px;
			margin-top: 2px;

			.chat-at-text {
				color: #c70b0b;
				font-size: var(--im-font-size-smaller);
			}

			.chat-send-name {
				font-size: var(--im-font-size-smaller);
				color: var(--im-text-color-light);
			}

			.chat-draft-text {
				color: var(--im-color-danger);
				font-size: var(--im-font-size-smaller);
				margin-right: 3px;
			}

			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-smaller);
				color: var(--im-text-color-light);
			}

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: var(--im-font-size-large);
				color: var(--im-text-color-lighter);
				margin-left: 5px;
				background: var(--im-background-active);
				border-radius: 50%;
				width: 20px;
				height: 20px;
			}

		}
	}

	.chat-top-badge {
		position: absolute;
		top: 0;
		right: 0;
		width: 22px;
		height: 22px;
		background: var(--im-color-primary-light-2);
		clip-path: polygon(0% 0%, 100% 100%, 100% 0%);
		border-radius: 0 8px 0 4px;
		z-index: 1;

		.icon {
			position: absolute;
			top: 2px;
			right: 2px;
			color: #fff;
			font-size: 10px;
			line-height: 1;
		}
	}
}
</style>
